module.exports = __webpack_public_path__ + "img/ej-logo-baseline.ae0d0e8d.jpg";